import * as React from 'react';
import classNames from 'classnames';
import PanelContext from '../PanelContext';
import { getLastDay } from '../utils/timeUtil';
import { getCellDateDisabled } from '../utils/dateUtil';
export default function PanelBody({ prefixCls, disabledDate, onSelect, picker, rowNum, colNum, prefixColumn, rowClassName, baseDate, getCellClassName, getCellText, getCellNode, getCellDate, generateConfig, titleCell, headerCells, }) {
    const { onDateMouseEnter, onDateMouseLeave, mode } = React.useContext(PanelContext);
    const cellPrefixCls = `${prefixCls}-cell`;
    // =============================== Body ===============================
    const rows = [];
    for (let i = 0; i < rowNum; i += 1) {
        const row = [];
        let rowStartDate;
        for (let j = 0; j < colNum; j += 1) {
            const offset = i * colNum + j;
            const currentDate = getCellDate(baseDate, offset);
            const disabled = getCellDateDisabled({
                cellDate: currentDate,
                mode,
                disabledDate,
                generateConfig,
            });
            if (j === 0) {
                rowStartDate = currentDate;
                if (prefixColumn) {
                    row.push(prefixColumn(rowStartDate));
                }
            }
            const title = titleCell && titleCell(currentDate);
            row.push(<td key={j} title={title} className={classNames(cellPrefixCls, Object.assign({ [`${cellPrefixCls}-disabled`]: disabled, [`${cellPrefixCls}-start`]: getCellText(currentDate) === 1 || (picker === 'year' && Number(title) % 10 === 0), [`${cellPrefixCls}-end`]: title === getLastDay(generateConfig, currentDate) ||
                        (picker === 'year' && Number(title) % 10 === 9) }, getCellClassName(currentDate)))} onClick={() => {
                    if (!disabled) {
                        onSelect(currentDate);
                    }
                }} onMouseEnter={() => {
                    if (!disabled && onDateMouseEnter) {
                        onDateMouseEnter(currentDate);
                    }
                }} onMouseLeave={() => {
                    if (!disabled && onDateMouseLeave) {
                        onDateMouseLeave(currentDate);
                    }
                }}>
          {getCellNode ? (getCellNode(currentDate)) : (<div className={`${cellPrefixCls}-inner`}>{getCellText(currentDate)}</div>)}
        </td>);
        }
        rows.push(<tr key={i} className={rowClassName && rowClassName(rowStartDate)}>
        {row}
      </tr>);
    }
    return (<div className={`${prefixCls}-body`}>
      <table className={`${prefixCls}-content`}>
        {headerCells && (<thead>
            <tr>{headerCells}</tr>
          </thead>)}
        <tbody>{rows}</tbody>
      </table>
    </div>);
}
